import React, { Component } from 'react';
import { BsFormControl, BsFormSelect, BsModalForm } from '../../collection/bootstrap/BootstrapComponents';
import Loading from '../../collection/icons/Loading';
import { apiForm, apiGet } from '../../utils/api';
import ListadoFechas from '../project/ListadoFechas';

export default function LocalidadModal(props) {
    const isNew = props.idLocalidad < 1;

    const updateData = async () => await apiGet("localidades/get/" + props.idLocalidad);

    const checkData = formData => {
        let errors = {}
        // Nombre
        const name = formData.get("name");
        if (!name) {
            errors["name"] = "Campo obligatorio";
        }
        return errors;
    }

    const saveData = async data => {
        const action = isNew ? "new" : "edit";
        const result = await apiForm("localidades/" + action, data);
        if (result) {
            props.onHide();
        }
    }

    return (
        <BsModalForm
            isNew={isNew}
            onUpdate={updateData}
            onCheck={checkData}
            onSave={saveData}
            modalTitle={isNew ? "Nueva localidad" : "Editar localidad"}
            show={props.show}
            onHide={props.onHide}
            idLocalidad={props.idLocalidad}>
            <LocalidadForm />
        </BsModalForm >
    );
}

class LocalidadForm extends Component {

    constructor(props) {
        super(props);
        this.state = { listLocalidades: null };
    }

    async componentDidMount() {
        let listUrl = "localidades/list";
        if (this.props.idLocalidad > 0) listUrl += "/" + this.props.idLocalidad;
        const list = await apiGet(listUrl);
        if (list) {
            this.setState({ listLocalidades: list });
        }
    }

    renderForm() {
        const data = this.props.data;
        const errors = this.props.errors;
        return <>
            <BsFormControl
                /* Nombre */
                label="Nombre" name="name"
                value={data.name} error={errors.name}
                maxLength="100" />
            <BsFormSelect
                /* Padre */
                label="Padre" name="padre"
                value={data.padre} error={errors.padre}
                options={this.state.listLocalidades}
                className="mt-3" isClearable />
            <ListadoFechas
                /* Festivos */
                label="Festivos" name="festivos[]"
                fechas={data.festivos}
                className="mt-3" />
        </>;
    }

    render() {
        return !(this.state.listLocalidades) ?
            <Loading /> : this.renderForm();
    }
}
